import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslateCacheService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly cacheName = 'lang';

  constructor(private readonly translateService: TranslateService) {}

  init(): void {
    this.translateService.onLangChange.subscribe(({ lang }) => {
      this.cacheWithLocalStorage(lang);
    });

    const currentLang = this.getCachedLanguage() || this.translateService.getBrowserLang();
    if (currentLang) {
      this.translateService.use(currentLang);
    }
  }

  getCachedLanguage(): string | undefined {
    if (!isPlatformBrowser(this.platformId)) {
      return undefined;
    }

    try {
      return window.localStorage.getItem(this.cacheName) ?? undefined;
    } catch {
      return undefined;
    }
  }

  private cacheWithLocalStorage(language: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      window.localStorage.setItem(this.cacheName, language);
    } catch {
      // Ignore storage restrictions, as the language can still be changed in memory.
    }
  }
}
